import React, { Component, Fragment } from 'react'
import { action, computed, observable, reaction } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import { CLEARANCE_COUNTRIES } from '../stores/QueryParamsStore'
import withAppStore from 'decorators/withAppStore'
import styles from 'shared/styles/components/Datepicker'
import { Dialog, List, ListItem, ListItemText } from 'material-ui'
import { Typography } from 'material-ui'

@withStyles(styles)
@withAppStore
@observer
export default class Direction extends Component {
  constructor(params) {
    super(params)
    this.options = Object.keys(CLEARANCE_COUNTRIES).map((key, index) => {
      return {
        key: key,
        value: CLEARANCE_COUNTRIES[key],
      }
    })
    this.state = {
      clearanceCountry: this.props.clearanceCountry,
    }
    this.handleListItemClick = this.handleListItemClick.bind(this)
  }

  componentWillMount() {
    reaction(
      () => {
        const { clearanceCountry } = this.appStore
        return { clearanceCountry }
      },
      ({ clearanceCountry }) => {
        this.setState({
          clearanceCountry: clearanceCountry,
        })
      },
    )
  }

  handleListItemClick = (item) => {
    this.setState({
      clearanceCountry: item.key,
    })
    this.appStore.clearanceCountry = item.key
    this.handleClose()
  }

  @observable isOpen = false

  @computed
  get label() {
    return CLEARANCE_COUNTRIES[this.state.clearanceCountry]
  }

  render() {
    const { classes, isMobile } = this.props

    return (
      <Fragment>
        <Button
          style={{ textTransform: "none", padding: '0px 0px' }}
          variant="flat"
          disableFocusRipple
          className={classes.button}
          onClick={this.handleOpen}
        >
          {isMobile && <Typography variant="caption">{this.label}</Typography>}
          {!isMobile && <Typography>{this.label}</Typography>}
        </Button>

        <Dialog onClose={this.handleClose} open={this.isOpen}>
          <List>
            {this.options.map((item) => (
              <ListItem
                button
                onClick={() => this.handleListItemClick(item)}
                key={item.key}
              >
                <ListItemText primary={item.value} />
              </ListItem>
            ))}
          </List>
        </Dialog>
      </Fragment>
    )
  }

  @action.bound
  handleOpen() {
    this.isOpen = true
  }

  @action.bound
  handleClose() {
    this.isOpen = false
  }
}



// WEBPACK FOOTER //
// ./src/components/ClearanceCountry.js